module.exports = __webpack_public_path__ + "img/D_Read_more_drinkcoach_app.86239d18.svg";